var exports = {
  "kL": "ReportFlowScreenView.module__container___Ty0ya3",
  "uW": "ReportFlowScreenView.module__section___Ty0ya3",
  "R_": "ReportFlowScreenView.module__heading___Ty0ya3",
};

module.exports = exports;
